module.exports = __webpack_public_path__ + "img/emba_g.1e4b8b5f.png";